<template>
  <div class="catalog-box box-shadow">
    <div>
      <!-- <b-card no-body>
        <b-row>
          <b-col md="3"></b-col>
          <b-col md="9">
            <b-row>
              <b-col md="6"></b-col>
              <b-col md="6"></b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>-->
      <b-card no-body>
        <b-tabs pills card>
          <b-tab
            :title="category"
            v-for="category in categoryData"
            v-bind:key="category"
            @click="categoryName($event)"
          >
            <div class="cat-listing">
              <ul class="list-inline mb-0">
                <li
                  class="list-inline-item"
                  v-for="item in catalogData"
                  v-bind:key="item.id"
                  @click="checkMultipleMrp(item)"
                  :id="item.barcode"
                >
                  <!-- <li class="list-inline-item" @click="checkProductInCart(product)"> -->
                  <a
                    href="#"
                    class="d-flex box-shadow"
                    :class="
                      state.system.settings.stock.negative_stock_billing
                        .status == 0 && parseInt(item.current_stock) <= 0
                        ? 'isDisabled'
                        : null
                    "
                  >
                    <!-- <img :src="imageExists(item.images)" alt /> -->
                    <img :src="imageExists(item.images)" alt />
                    <!-- <img
                      v-if="item.images != 'default/zwing_default.png' && state.system.isOffline == false"
                      :src="imageExists(item.images)"
                      alt
                    />-->
                    <!-- <img
                      v-if="item.images == 'default/zwing_default.png' && state.system.theme == 'theme-light' || state.system.isOffline == true && state.system.theme == 'theme-light'"
                      src="../assets/images/zwing_default.png"
                      class="light-img"
                      alt
                    />
                    <img
                      v-if="item.images == 'default/zwing_default.png' && state.system.theme == 'theme-dark' || state.system.isOffline == true && state.system.theme == 'theme-dark'"
                      src="../assets/images/zwing_default_dark.png"
                      class="dark-img"
                      alt
                    />-->
                    <div class="product-info pull-left">
                      <h6 class="mb-0" v-text="item.name.slice(0, 80)"></h6>
                      <span v-text="currencySymbol + formatAmount(item.mrp)" />
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>

    <!-- categories  listing-->

    <update-qty-modal
      :open="openBox"
      :data="productDetails"
      @close-modal="boxClose"
      :toCart="true"
    />
    <multiple-mrp-modal
      :multipleMrp="multipleMrp"
      :prod="prodDet"
      @close-multiple="closeMrp"
    ></multiple-mrp-modal>
    <catalog-progress-modal
      :catalogProg="catalogProg"
      @updateHide="updateStatus"
    ></catalog-progress-modal>
    <batch-serial-modal
      :open="openBatchSerial"
      :batchSerialData="batchSerialData"
      @closeBatchSerialModal="closeBatchSerial"
    />
    <div class="clearfix"></div>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";
import axios from "axios";
import { mapState } from "vuex";
import UpdateQtyModal from "./UpdateQtyModal";
import multipleMrpModal from "./multipleMrpModal";
import Catalog from "../store/modules/catalog";
import * as msg from "../message";
import CatalogProgressModal from "./CatalogProgressModal";
import db from "../database";
import BatchSerialModal from "./BatchSerialModal";
import * as socket from "../socket";
import * as helper from "../helper";

export default {
  name: "product-catalog",
  components: {
    carousel,
    UpdateQtyModal,
    multipleMrpModal,
    CatalogProgressModal,
    BatchSerialModal,
  },
  props: {
    isDisplay: false,
  },
  data() {
    return {
      openBox: false,
      products: [],
      productDetails: "",
      multipleMrp: false,
      prodDet: "",
      catalogProg: false,
      catalogData: [],
      categoryData: [],
      activeIndex: "",
      source: require("../assets/images/zwing_default.png"),
      openBatchSerial: false,
      batchSerialData: {},
    };
  },
  watch: {
    isDisplay() {
      if (this.isDisplay == true) {
        if (this.state.system.is_catalog == 1) {
          // this.fetchProducts();
          if (this.catalogData == "") {
            this.showCategoryProducts();
          }
        }
      }
    },
    globalLoading(old, newVal) {
      if (!old) {
        this.$loading = false;
      }
    },
  },
  mounted() {
    // this.fetchProducts();
    // if (this.state.is_catalog == 1) {
    //   this.fetchProducts();
    // }
    this.getCatalogData();
  },
  computed: {
    ...mapState({
      state: (state) => state,
      customerData() {
        return this.$store.getters["sessions/getCustomerParam"];
      },
    }),
    globalLoading() {
      return this.state.sessions.syncLoading;
    },
  },

  methods: {
    closeBatchSerial() {
      this.openBatchSerial = false;
    },
    async getCatalogData() {
      if ((await helper.countProducts()) == 0) {
        this.$store.commit("products/clearProgress");
        this.state.sessions.syncLoading = true;
        this.catalogProg = true;
        this.$loading = true;
        this.$store.dispatch("offline/saveOfflineStoreProducts").then(() => {
          this.$loading = false;
        });
      }
      // else {
      // setTimeout(() => {
      // socket.getItems();
      // }, 20000);
      // }
    },
    categoryName(event) {
      let category = "";
      if (this.catalogData.length == 0) {
        category = this.activeIndex;
      } else {
        category = event.target.text;
      }
      let self = this;
      let data = [];
      // let category = this.categoryData[this.activeIndex];
      db.transaction("r", db.products, async () => {
        await db.products
          .where("category")
          .equals(category)
          .limit(100)
          .each((item) => {
            data.push(item);
          });
      });
      this.catalogData = data;
    },
    showCategoryProducts() {
      let data = [];
      db.transaction("r", db.products, async () => {
        await db.products.orderBy("category").eachUniqueKey((item) => {
          data.push(item);
        });
      }).then(() => {
        this.categoryData = data;
        this.activeIndex = data[0];
        this.categoryName();
      });
    },
    // checkProductInCart(pdata) {
    //   // console.log(pdata);
    //   if (pdata.weight_flag) {
    //     this.addToCart(pdata);
    //   } else {
    //     // console.log(pdata);
    //     if (this.state.billing.billing.cart != "") {
    //       var info = true;
    //       let count = 1;
    //       if (this.state.billing.billing.cart.data.length != 0) {
    //         this.state.billing.billing.cart.data.map(item => {
    //           if (item.product_data.barcode == pdata.barcode) {
    //             console.log("[Update Qty]");
    //             if (
    //               parseInt(item.qty) ==
    //               parseInt(this.state.billing.billing.cart.product_max_qty)
    //             ) {
    //               let alertData = {
    //                 message: msg.MAX_PRODUCT_QTY,
    //                 type: "danger"
    //               };
    //               this.$store.commit("notifications/showAlert", alertData);
    //               this.$showAlert = true;
    //             } else {
    //               var value = parseInt(item.qty) + 1;
    //               var prodData = item.product_data;
    //               this.updateToCart(pdata, value, prodData);
    //             }
    //             info = false;
    //           } else if (
    //             info == true &&
    //             count == this.state.billing.billing.cart.data.length
    //           ) {
    //             // console.log(
    //             //   "count: " +
    //             //     count +
    //             //     " cart len: " +
    //             //     this.state.billing.billing.cart.data.length
    //             // );
    //             this.addToCart(pdata);
    //           }
    //           count += 1;
    //         });
    //       } else {
    //         this.addToCart(pdata);
    //       }
    //     } else {
    //       this.addToCart(pdata);
    //     }
    //   }
    // },
    // updateToCart(pdata, value, prodData) {
    //   this.$loading = true;
    //   let productData = {
    //     barcode: pdata.barcode,
    //     scan: "TRUE",
    //     url: "product-qty-update",
    //     qty: value,
    //     change_mrp: "",
    //     unit_mrp: prodData.unit_mrp,
    //     r_price: prodData.r_price,
    //     s_price: prodData.s_price,
    //     amount: "",
    //     discount: "",
    //     pdata: ""
    //   };
    //   let data = Object.assign(
    //     productData,
    //     this.essentialsData,
    //     this.customerData
    //   );
    //   this.$store
    //     .dispatch("billing/updateToCart", data)
    //     .then(res => {
    //       this.$store.dispatch("billing/cartDetails").then(() => {
    //         this.$loading = false;
    //       });
    //     })
    //     .catch(err => {
    //       console.log(err.response);
    //       this.$loading = false;
    //       // this.$bvModal.msgBoxOk(err.response.data.message);
    //     });
    // },
    checkMultipleMrp(pdata) {
      if (pdata.is_batch == 1 && pdata.batch != "") {
        this.batchSerialData.batchList = pdata.batch;
        this.batchSerialData.pdata = pdata;
        this.batchSerialData.type = "Batch";
        this.openBatchSerial = true;
      } else if (pdata.is_serial == 1 && pdata.serial != "") {
        this.batchSerialData.batchList = pdata.serial;
        this.batchSerialData.pdata = pdata;
        this.batchSerialData.type = "Serial";
        this.openBatchSerial = true;
      } else if (pdata.multiple_price.length > 1) {
        this.prodDet = pdata;
        this.multipleMrp = true;
      } else {
        this.checkProductInCart(pdata);
      }
    },
    checkProductInCart(pdata) {
      if (pdata.weight_flag) {
        this.addToCart(pdata);
      } else {
        let existsItem = this.state.billing.billing.cart.data.filter((item) => {
          return item.product_data.barcode == pdata.barcode;
        });
        if (existsItem.length == 0) {
          this.addToCart(pdata);
        } else {
          console.log(
            existsItem[0].product_data.barcode + " " + existsItem[0].qty
          );
          if (
            parseInt(existsItem[0].qty) ==
            parseInt(this.state.system.settings.cart.product_max_qty)
          ) {
            console.log("max qty reached");
            let alertData = {
              message: msg.MAX_PRODUCT_QTY,
              type: "danger",
            };
            this.$store.commit("notifications/showAlert", alertData);
            this.$showAlert = true;
          } else {
            this.addToCart(pdata);
          }
        }
      }
    },
    fetchProducts: function() {
      this.$loading = true;
      var data = {
        api_token: this.state.sessions.user.api_token,
        // c_id: "",
        v_id: this.state.sessions.user.vendor_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        trans_from: this.state.system.trans_from,
        url: "/vendor/get-catalog",
      };
      if (this.state.products.data == "") {
        // this.$refs["catalog-progress-modal"].show();
        this.catalogProg = true;
        let postData = Object.assign(
          data,
          this.essentialsData,
          this.customerData
        );
        axios
          .post(data.url, postData)
          .then((response) => {
            // this.products = response.data;
            this.$store.commit(
              "products/offlineItems",
              response.data.catalog_data
            );
            this.$store.dispatch(
              "offline/saveOfflineStoreProducts",
              response.data.catalog_data
            );
            this.$loading = false;
          })
          .catch((err) => {
            console.log(err.response);
            this.$loading = false;
          });
      } else {
        this.$loading = false;
        // this.$refs["catalog-progress-modal"].hide();
        this.catalogProg = false;
      }
    },
    addToCart(pdata) {
      if (
        this.state.billing.billing.cart != "" &&
        this.state.billing.billing.cart.data.length >=
          this.state.system.settings.cart.cart_max_item
      ) {
        let alertData = {
          message: msg.MAX_CART_ITEMS,
          type: "danger",
        };
        this.$store.commit("notifications/showAlert", alertData);
        this.$showAlert = true;
      } else if (
        (pdata.is_batch == "1" && pdata.batch.length == 0) ||
        (pdata.is_serial == "1" && pdata.serial.length == 0)
      ) {
        this.barcode = "";
        this.$showAlert = true;
        this.$store.commit("notifications/showAlert", {
          message: pdata.is_batch == 1 ? msg.NO_BATCH : msg.NO_SERIAL,
          type: "danger",
        });
        return;
      } else {
        if (pdata.weight_flag) {
          this.openBox = true;
          this.productDetails = pdata;
          if (typeof Android !== "undefined" && Android !== null) {
            let postData = { type: "read_weight", data: "" };
            returnValue(postData);
          }
        } else {
          this.$loading = true;
          let productData = {
            barcode: pdata.barcode,
            scan: "TRUE",
            url: "product-details",
            qty: "",
            change_mrp: "",
            batch_id: "0",
            serial_id: "0",
            cust_gstin: this.state.billing.billing.customer.data.hasOwnProperty(
              "gstin"
            )
              ? this.state.billing.billing.customer.data.gstin
              : "",
          };
          if (this.state.system.isOffline) {
            productData = Object.assign({ unit_mrp: pdata.mrp }, productData);
          }
          let data = Object.assign(
            productData,
            this.essentialsData,
            this.customerData
          );
          // console.log(pdata);
          this.$store
            .dispatch("billing/addToCart", data)
            .then((res) => {
              if (!this.state.system.isOffline && res.data.status == "fail") {
                let alertData = {
                  message: res.data.message,
                  type: "danger",
                };
                this.$showAlert = true;
                this.$store.commit("notifications/showAlert", alertData);
                this.$loading = false;
              } else
                this.$store.dispatch("billing/cartDetails").then(() => {
                  this.$loading = false;
                });
            })
            .catch((err) => {
              if (err.response.data.status == "fail") {
                let alertData = {
                  message: err.response.data.message,
                  type: "danger",
                };
                this.$showAlert = true;
                this.$store.commit("notifications/showAlert", alertData);
              } else if (err.response.data.status == "product_not_found") {
                let alertData = {
                  message: err.response.data.message,
                  type: "danger",
                };
                this.$showAlert = true;
                this.$store.commit("notifications/showAlert", alertData);
              }
              this.$loading = false;
            });
          // .catch((err) => {
          //   // console.log(err);
          //   // console.log(err.response);
          //   // this.$bvModal.msgBoxOk(err.response.data.message);
          // });
        }
      }
    },
    updateStatus() {
      if (this.catalogProg == true) {
        this.catalogProg = false;
      }
    },
    boxClose(data) {
      this.openBox = data;
    },
    closeMrp(data) {
      this.multipleMrp = data;
    },
    imageExists(url) {
      let light_dark = "";
      let is_error = false;
      let baseUrl =
        this.state.system.settings.image_path +
        "product/" +
        this.state.system.settings.v_id.toString() +
        "/";
      // baseUrl = baseUrl.replace("dev", "test");

      if (this.state.system.theme == "theme-light") {
        light_dark = "zwing_default.png";
      } else {
        light_dark = "zwing_default_dark.png";
      }

      // let image = document.createElement("img");
      // image.src = baseUrl + url;
      // image.onload = () => {
      //   // console.log("load");
      // };
      // image.onerror = err => {
      //   is_error = true;
      //   baseUrl = url;
      // };
      // console.log(baseUrl);
      // console.log(is_error);
      if (
        is_error ||
        url == "default/zwing_default.png" ||
        this.state.system.is_offline
      ) {
        return require("../assets/images/" + light_dark);
      } else {
        return baseUrl + url;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.cat-listing {
  height: calc(100vh - 242px);
}
.cat-listing ul li a img {
  height: auto;
}

.theme-light .product-info span {
  color: #808080;
}

.product-catalog-wrapper .card .card-header {
  padding: 0;
  border: 0;
}
.dark-img,
.light-img {
  display: none;
}
.theme-light .light-img,
.theme-dark .dark-img {
  display: block;
}
.theme-light .dark-img,
.theme-dark .ligth-img {
  display: none;
}
// .product-catalog-wrapper .catalog-box {
//   background: #e8e8e8;
// }
.tabs {
  display: inline-flex;
  ul li a {
    padding: 0.7rem 1rem;
  }
}
.catalog-box .tabs .card-header.tabs .card-header {
  width: 30% !important;
}
// .product-catalog-wrapper .tabs .card-header .card-header-pills {
//   display: flex;
// }
.product-catalog-wrapper .tabs .card-header {
  border-bottom-left-radius: 5px !important;
}
.catalog-box .card .card-body {
  padding: 5px;
}
.isDisabled {
  color: currentColor;
  cursor: not-allowed;
  opacity: 0.5;
  text-decoration: none;
}
</style>
